import styled, { css } from "styled-components";

// Reusable card styling helper
const CardMixin = css`
  border-radius: 4px;
  border: 1px solid #ecf1f4;
  background: #fff;
`;

export const StyledCartPageContainerDiv = styled.div`
  padding: 32px 136px;
  font-family: Inter, sans-serif;
  background: #fcfdfe;
  min-height: calc(100vh - 180px);
  display: flex;
  flex-direction: column;
`;

export const StyledContinueBrowsingLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: none;
  background: #fff;
  padding: 8px 16px;
  cursor: pointer;
  margin-bottom: 24px;
  width: max-content;

  ${CardMixin}

  color: var(--GREY, #4a4a68);
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */

  svg {
    width: 16px;
    height: 16px;
    color: #4a4a68;
  }

  &:hover {
    background: #f7f8f9;
  }
`;

export const StyledCartMainContentDiv = styled.div`
  display: flex;
  gap: 36px; /* Gap between table and order summary */
  align-items: flex-start;
  margin-top: 8px;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const StyledCartTableContainerDiv = styled.div`
  flex: 1.6;
  ${CardMixin}
  display: flex;
  flex-direction: column;
`;

export const StyledCartTableHeaderContainerDiv = styled.div`
  display: flex;
  padding: 16px 24px;
  border-bottom: 1px solid #ecf1f4;
  align-items: center;
`;

export const StyledCartTableHeaderDiv = styled.div`
  color: var(--Grey, #5c5c77);
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 150% */
  letter-spacing: 0.36px;
  text-transform: uppercase;

  &.product {
    flex: 2;
    text-align: left;
  }
  &.unit-price {
    flex: 1;
    text-align: right;
  }
  &.qty {
    flex: 1.2;
    text-align: center;
  }
  &.total {
    flex: 1.2;
    text-align: right;
  }
`;

export const StyledCartTableBodyDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledCartTableRowDiv = styled.div`
  display: flex;
  padding: 24px;
  align-items: center;
  border-bottom: 1px solid #ecf1f4;

  &:last-child {
    border-bottom: none;
  }
`;

export const StyledCartTableRowItemDiv = styled.div`
  &.product {
    flex: 2;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  &.unit-price {
    flex: 1;
    text-align: right;
    color: #4a4a68;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
  }
  &.qty {
    flex: 1.2;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
  }
  &.total {
    flex: 1.2;
    text-align: right;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }

  .total-value {
    color: #0e0e2c;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 16.8px */
  }
`;

export const StyledRemoveButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px; /* gap 10px btw text and icon */
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;

  color: #cf324a;
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */

  svg {
    width: 16px;
    height: 16px;
    color: #cf324a;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const StyledCartSidebarContainerDiv = styled.div`
  max-width: 332px;
  display: flex;
  flex-direction: column;
  gap: 24px; /* gap between order summary and details */
`;

export const StyledSidebarCard = styled.div`
  ${CardMixin}
  padding: 24px;
  display: flex;
  flex-direction: column;
`;

export const StyledSidebarHeader = styled.h3`
  color: #0e0e2c;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 16.8px */
  margin: 0 0 16px 0;
`;

export const StyledSummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.subtotal,
  &.tax {
    .label,
    .value {
      color: #4a4a68;
      font-family: Inter, sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; /* 14.4px */
    }
    .value {
      text-align: right;
    }
  }

  &.total {
    border-top: 1px solid #ecf1f4;
    padding-top: 16px;
    margin-top: 16px;
    margin-bottom: 16px;

    .label,
    .value {
      color: #0e0e2c;
      font-family: Inter, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%; /* 16.8px */
    }
  }
`;

export const StyledSubmitButton = styled.button`
  border-radius: 4px;
  background: #1249bf;
  color: #fff;
  border: none;
  padding: 10px 16px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  width: 100%;
  margin-bottom: 12px;

  &:hover {
    background: #0f3da3;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const StyledSidebarContinueBrowsingButton = styled.button`
  border-radius: 4px;
  background: #f7f8f9;
  border: 1px solid #ecf1f4;
  padding: 10px 16px;
  cursor: pointer;
  width: 100%;

  color: var(--GREY, #4a4a68);
  text-align: center;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;

  &:hover {
    background: #eef0f2;
  }
`;

export const StyledDisclaimer = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin-top: 16px;
  color: #676879;
  font-size: 11px;
  line-height: 1.4;

  svg {
    width: 14px;
    height: 14px;
    color: #676879;
    flex-shrink: 0;
    margin-top: 2px;
  }

  span {
    font-family: Inter, sans-serif;
  }
`;

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  label {
    color: var(--GREY, #4a4a68);
    font-feature-settings:
      "liga" off,
      "clig" off;
    font-family: Inter, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 166.667% */
  }

  input,
  textarea {
    width: 100%;
    border-radius: 4px;
    border: 1px solid #ecf1f4;
    padding: 8px 12px;
    background: #fff;
    outline: none;

    overflow: hidden;
    color: var(--ASH, #676879);
    text-overflow: ellipsis;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */

    &::placeholder {
      color: var(--ASH, #676879);
      opacity: 0.6;
    }

    &:focus {
      border-color: #2060ea;
    }
  }

  textarea {
    resize: vertical;
    min-height: 80px;
  }
`;

export const CheckoutSuccessContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 12px 0 0;
  font-family: Inter, sans-serif;

  .success-icon {
    font-size: 48px;
    color: #52c41a;
    margin-bottom: 16px;
  }

  h3 {
    color: #0e0e2c;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 8px;
  }

  p {
    color: #676879;
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 24px;
  }

  .btn-container {
    display: flex;
    gap: 12px;
    width: 100%;

    button {
      flex: 1;
      height: 32px;
      font-weight: 500;
      border-radius: 4px;

      &.order-btn {
        &:disabled {
          color: #fff;
        }
      }
    }
  }
`;

export const CartEmptyState = styled.div`
  padding: 48px;
  text-align: center;
  color: #676879;
  font-family: Inter, sans-serif;
  font-size: 14px;
`;
